/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Advertisement} from '../../../../../types/ad.types'
import {isImageUrl} from '../../../../../helper/imageHelpers'

type Props = {
  email: string
}

const ReportInfoCell: FC<Props> = ({email}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='d-flex flex-column'>
      <div className='text-gray-800 mb-1'>{email}</div>
    </div>
  </div>
)

export {ReportInfoCell}
